let viewArr = networkList;
let warehouseList = [];
let truckList = [];
let etcList = [];
let viewAmount = 6; //한번에 노출되는 리스트 수
let pageNumMax = 5; //Paination 노출 수
const $locationDomesticNetworksStatus = $('.location_domestic-networks-status');
const $domesticNetworksCounts = $('.domestic-networks-count');
const $networkListView = $('.domestic-networks-list-table .btn-view-list');
const $networkList = $('.domestic-networks-list-table .list');
const $networkCategory = $('.domestic-networks-list-table .category');
let hiddenSize = $networkList.find('li:hidden').length;

let gfn_lang = $('html').attr('lang');
let warehouse = gfn_lang != 'en' ? '물류센터' : 'ct_warehouse';
let transport = gfn_lang != 'en' ? '운송센터' : 'ct_transport';
let etc = gfn_lang != 'en' ? '타 사업부' : 'ct_etc';

const network = {
    init: function () {
        //카테고리별로 배열 생성
        this.makeArr(warehouse, warehouseList);
        this.makeArr(transport, truckList);
        this.makeArr(etc, etcList);

        //최초 리스트, pagination 세팅
        this.set();

        //지도에 카테고리별 숫자 입력
        $domesticNetworksCounts.find('div').each(function () {
            let name = $(this).find('.name').text();
            $(this).find('ul').empty().append(`
                <li class="warehouse">${network.count(name, warehouse)}</li>
                <li class="truck">${network.count(name, transport)}</li>
                <li class="office">${network.count(name, etc)}</li>
                `);
        });
    },
    //최초, 카테고리 변경 시 SET
    set: function () {
        this.selectCategory(); //카테고리변경 및 pagination 생성
        this.makeList();
        this.hiddenSize();
    },
    //카테고리별 배열 생성
    makeArr: function (category, arr) {
        let count = 0;
        $.each(networkList, function (i) {
            if (this.category == category) {
                arr[count] = this;
                arr[count].index = count;
                count++;
            }
        });
    },
    //카테고리 선택 시 배열 교체 + Pagination 버튼 생성
    selectCategory: function () {
        //초기화
        $domesticNetworksCounts.removeClass(
            'only-warehouse only-truck only-office',
        );
        let category = $networkCategory.find('.is-active').data('category');
        if (category == 'all') {
            viewArr = networkList;
        } else if (category == 'warehouse') {
            viewArr = warehouseList;
            $domesticNetworksCounts.addClass('only-warehouse');
        } else if (category == 'truck') {
            viewArr = truckList;
            $domesticNetworksCounts.addClass('only-truck');
        } else if (category == 'etc') {
            viewArr = etcList;
            $domesticNetworksCounts.addClass('only-office');
        }
    },
    makeList: function () {
        //reset
        $networkList.empty();
        let count = 0;
        $.each(viewArr, function (i) {
            info = `
                <li ${i >= 5 ? 'hidden' : ''}>
                    <i class="lx_icon-wnd-pin-grey-20"></i>
                    <strong class="name">${this.name}</strong>
                    ${
                        this.goods
                            ? `<span class="goods">${this.goods}</span>`
                            : ''
                    }
                    <p class="address">${this.address}</p>
                </li>
                `;
            $networkList.append(info);
            count++;
        });
        return count;
    },
    //지역별, 카테고리별 갯수 세기
    count: function (area, category) {
        let countArr = networkList.filter(
            (item) => item.area == area && item.category == category,
        );
        return countArr.length;
    },
    viewMore: function (amount) {
        $networkList.find('li:hidden').each(function (i) {
            if (i >= amount) return false;
            $(this).removeAttr('hidden');
            i++;
        });
        this.hiddenSize();
    },
    hiddenSize: function () {
        hiddenSize = $networkList.find('li:hidden').length;
        hiddenSize ? $networkListView.show() : $networkListView.hide();
    },
};

network.init();

//TAB (카테고리 선택 - 지도 반영분)
$networkCategory.on('click', 'button', function () {
    $(this).addClass('is-active').siblings('button').removeClass('is-active');
    network.set();
});
$networkListView.on('click', function () {
    //$(this).hide();
    //$networkList.find('li[hidden]').removeAttr('hidden');
    network.viewMore(5);
});
